import { EpNodeDetail } from '@bumble/app/__generated__/data-contracts';
import { Loading } from '@bumble/app/components/Loading';
import NoData from '@bumble/app/components/NoData';
import { TabGrid, TabGridStructure } from '@bumble/app/components/TabGrid';
import { Indicator } from '@bumble/app/components/Indicator';
import getDate from '@bumble/app/utils/get-date';

export const EndpointNodeTabDetails = ({
  data,
  loading,
}: {
  data: EpNodeDetail | undefined;
  loading: boolean;
}) => {
  if (loading) return <Loading />;
  if (data === undefined) return <NoData />;

  const tabData: TabGridStructure[] = [
    {
      label: 'Endpoint Node Name',
      content: data?.ep_node_name || 'N/A',
    },
    {
      label: 'Created at',
      content: data !== undefined && data?.created_at ? getDate(data?.created_at) : 'N/A',
    },
    {
      label: 'Admin State',
      content: data?.admin_state || 'N/A',
    },
    {
      label: 'Admin State Change at',
      content:
        data !== undefined && data?.admin_state_change_at
          ? getDate(data?.admin_state_change_at)
          : 'N/A',
    },
    {
      label: 'OP State',
      content: data?.op_state !== undefined ? <Indicator active={data?.op_state === 'up'} /> : 'N/A',
    },
    {
      label: 'OP State Change at',
      content:
        data !== undefined && data?.op_state_change_at ? getDate(data?.op_state_change_at) : 'N/A',
    },
    {
      label: 'Account Id',
      content: data?.account_id || 'N/A',
    },
    {
      label: 'Endpoint Node Id',
      content: data?.ep_node_id || 'N/A',
    },
    {
      label: 'Endpoint Node Group Id',
      content: data?.ep_node_group_id || 'N/A',
    },
    {
      label: 'Endpoint Node Group Name',
      content: data?.ep_node_group_name || 'N/A',
    },
    {
      label: 'Primary IP',
      content: data?.primary_ip || 'N/A',
    },
    {
      label: 'Secondary IPs',
      content: data?.secondary_ips || 'N/A',
    },
    {
      label: 'Form Factor',
      content: data?.form_factor || 'N/A',
    },
    {
      label: 'Shipping Addr',
      content: data?.shipping_addr || 'N/A',
    },
  ];
  return <TabGrid data={tabData} />;
};
